import { render, staticRenderFns } from "./approvalSettings.vue?vue&type=template&id=39f15278&scoped=true&"
import script from "./approvalSettings.vue?vue&type=script&lang=js&"
export * from "./approvalSettings.vue?vue&type=script&lang=js&"
import style0 from "./approvalSettings.vue?vue&type=style&index=0&id=39f15278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f15278",
  null
  
)

export default component.exports